import React, {useEffect, useState} from "react";
import {WidgetProps} from "../../../../../../common/smart-table/filter/dropdown/widget/widget";
import {Select} from "antd";
import {propertyService} from "../../../../../../../services/property/property.service";
import {SystemUser} from "../../../../../../../models/users/user/system.user";

export const ResponsiblePersonWidget: React.FC<WidgetProps> = ({onChange, value}) => {

    const [values, setValues] = useState<SystemUser[]>([]);

    useEffect(() => {
        propertyService.getAllResponsibleUsers().then(values => {
            setValues(values);
        });
    }, []);

    return (
        <Select
            mode={"multiple"}
            onChange={onChange as any}
            value={value.map(v => parseInt(v as string))}
            style={{width: '250px'}}
            allowClear={true}
            showSearch
            optionFilterProp={"children"}
        >
            {values.map(v =>
                <Select.Option key={v.id} value={v.id}>{v.firstName} {v.lastName}</Select.Option>)}
        </Select>
    )
}